<div class="main">
    <div class="mobile">
        <ng-container *ngIf="landingImages">
            <ng-container *ngIf="landingImages.length == 1; else multiImageMobile">
                <div class="border-1 surface-border border-round m-2 p-3">
                    <img src="{{landingImages[0]}}">
                </div>
            </ng-container>
            <ng-template #multiImageMobile>
                <p-carousel [value]="landingImages" [numVisible]="1" [numScroll]="1" [circular]="true"
                    autoplayInterval="3000">
                    <ng-template let-image pTemplate="item">
                        <div class="border-1 surface-border border-round m-2 p-3">
                            <img src="{{image}}">
                        </div>
                    </ng-template>
                </p-carousel>
            </ng-template>
        </ng-container>
    </div>
    <!-- メインコンテンツ -->
    <div class="main-content">
        <!-- タイトル -->
        <!--Landing Image-->
        <div class="service-image p-d-flex p-jc-center p-mb-3 p-col-12">
            <div class="border-1 surface-border border-round m-2 p-3">
                <img alt="コドモミライコネクトのメインビジュアル" src="https://fukuoka-prod-file.s3.ap-northeast-1.amazonaws.com/common/landhing-page/slide/landing-image1.png">
            </div>
        </div>

        <div class="page-title">
            <label class="name">コドモミライコネクトでできること
            </label>
        </div>
        <div class="service-image p-col-12 p-mb-3">
            <img alt="コドモミライコネクトでできること" src="https://fukuoka-prod-file.s3.ap-northeast-1.amazonaws.com/common/landhing-page/slide/landing-image0.png">
        </div>
        <div class="container desktop">
            <div class="container-box">
                <div class="page-title">
                    <label class="name">利用登録方法解説動画
                    </label>
                </div>
                <div class="video-service">
                    <a href="https://fukuoka-prod-file.s3.ap-northeast-1.amazonaws.com/common/movie/%E3%82%B3%E3%83%89%E3%83%A2%E3%83%9F%E3%83%A9%E3%82%A4%E3%82%B3%E3%83%8D%E3%82%AF%E3%83%88%E5%88%A9%E7%94%A8%E7%99%BB%E9%8C%B2%E6%96%B9%E6%B3%95%E8%A7%A3%E8%AA%AC%E5%8B%95%E7%94%BB.mp4" target="_blank">
                        <img alt="利用登録方法解説動画" src="https://fukuoka-prod-file.s3.ap-northeast-1.amazonaws.com/common/movie/%E3%82%B3%E3%83%89%E3%83%A2%E3%83%9F%E3%83%A9%E3%82%A4%E3%82%B3%E3%83%8D%E3%82%AF%E3%83%88%E5%88%A9%E7%94%A8%E7%99%BB%E9%8C%B2%E6%96%B9%E6%B3%95%E8%A7%A3%E8%AA%AC%E5%8B%95%E7%94%BB%E3%82%A2%E3%82%A4%E3%82%B3%E3%83%B3%E7%94%BB%E5%83%8F.png">
                    </a>
                </div>
            </div>
            <div class="container-box">
                <div class="page-title">
                    <label class="name">マッチングのポイント解説動画
                    </label>
                </div>
                <div class="video-tutorial">
                    <a href="https://fukuoka-prod-file.s3.ap-northeast-1.amazonaws.com/common/movie/%E3%82%B3%E3%83%89%E3%83%A2%E3%83%9F%E3%83%A9%E3%82%A4%E3%82%B3%E3%83%8D%E3%82%AF%E3%83%88%E3%83%9E%E3%83%83%E3%83%81%E3%83%B3%E3%82%B0%E3%81%AE%E3%83%9D%E3%82%A4%E3%83%B3%E3%83%88%E8%A7%A3%E8%AA%AC%E5%8B%95%E7%94%BB.mp4" target="_blank">
                        <img alt="マッチングのポイント解説動画" src="https://fukuoka-prod-file.s3.ap-northeast-1.amazonaws.com/common/movie/%E3%82%B3%E3%83%89%E3%83%A2%E3%83%9F%E3%83%A9%E3%82%A4%E3%82%B3%E3%83%8D%E3%82%AF%E3%83%88%E3%83%9E%E3%83%83%E3%83%81%E3%83%B3%E3%82%B0%E3%81%AE%E3%83%9D%E3%82%A4%E3%83%B3%E3%83%88%E8%A7%A3%E8%AA%AC%E5%8B%95%E7%94%BB%E3%82%A2%E3%82%A4%E3%82%B3%E3%83%B3%E7%94%BB%E5%83%8F.png">
                    </a>
                </div>
            </div>
        </div>
        <div class="mobile">
            <div class="container-box-mobile">
                <div class="page-title">
                    <label class="name">利用登録方法解説動画
                    </label>
                </div>
                <div class="iframe-mobile">
                    <a href="https://fukuoka-prod-file.s3.ap-northeast-1.amazonaws.com/common/movie/%E3%82%B3%E3%83%89%E3%83%A2%E3%83%9F%E3%83%A9%E3%82%A4%E3%82%B3%E3%83%8D%E3%82%AF%E3%83%88%E5%88%A9%E7%94%A8%E7%99%BB%E9%8C%B2%E6%96%B9%E6%B3%95%E8%A7%A3%E8%AA%AC%E5%8B%95%E7%94%BB.mp4" target="_blank">
                        <img alt="利用登録方法解説動画" src="https://fukuoka-prod-file.s3.ap-northeast-1.amazonaws.com/common/movie/%E3%82%B3%E3%83%89%E3%83%A2%E3%83%9F%E3%83%A9%E3%82%A4%E3%82%B3%E3%83%8D%E3%82%AF%E3%83%88%E5%88%A9%E7%94%A8%E7%99%BB%E9%8C%B2%E6%96%B9%E6%B3%95%E8%A7%A3%E8%AA%AC%E5%8B%95%E7%94%BB%E3%82%A2%E3%82%A4%E3%82%B3%E3%83%B3%E7%94%BB%E5%83%8F.png">
                    </a>
                </div>
            </div>
            <div class="container-box-mobile">
                <div class="page-title">
                    <label class="name">マッチングのポイント解説動画
                    </label>
                </div>
                <div class="iframe-mobile">
                    <a href="https://fukuoka-prod-file.s3.ap-northeast-1.amazonaws.com/common/movie/%E3%82%B3%E3%83%89%E3%83%A2%E3%83%9F%E3%83%A9%E3%82%A4%E3%82%B3%E3%83%8D%E3%82%AF%E3%83%88%E3%83%9E%E3%83%83%E3%83%81%E3%83%B3%E3%82%B0%E3%81%AE%E3%83%9D%E3%82%A4%E3%83%B3%E3%83%88%E8%A7%A3%E8%AA%AC%E5%8B%95%E7%94%BB.mp4" target="_blank">
                        <img alt="マッチングのポイント解説動画" src="https://fukuoka-prod-file.s3.ap-northeast-1.amazonaws.com/common/movie/%E3%82%B3%E3%83%89%E3%83%A2%E3%83%9F%E3%83%A9%E3%82%A4%E3%82%B3%E3%83%8D%E3%82%AF%E3%83%88%E3%83%9E%E3%83%83%E3%83%81%E3%83%B3%E3%82%B0%E3%81%AE%E3%83%9D%E3%82%A4%E3%83%B3%E3%83%88%E8%A7%A3%E8%AA%AC%E5%8B%95%E7%94%BB%E3%82%A2%E3%82%A4%E3%82%B3%E3%83%B3%E7%94%BB%E5%83%8F.png">
                    </a>
                </div>
            </div>
        </div>

        <div class="page-title p-mb-2 pos-relarive">
            <label class="name">お知らせ</label>
            <button pButton label="お知らせ一覧" icon="pi pi-angle-right" iconPos="right" class="navigate-button"
                (click)="move('pages/platform/e001/1')"></button>
        </div>
        <div class="card notification-container p-mb-3">
            <ng-container *ngFor="let notice of listNotice">
                <div class="notification cursor" (click)="move('pages/platform/e002/' + notice?.information_id)">
                    <div class="date">
                        <ul class="bp">
                            <li>
                                {{ notice?.publishe_start }}
                            </li>
                        </ul>
                    </div>
                    <div class="message">
                        {{ notice?.title }}
                    </div>
                </div>
            </ng-container>
        </div>

        <div class="page-title p-mb-2 pos-relarive">
            <label class="name">連携事例</label>
            <button pButton label="連携事例一覧" icon="pi pi-angle-right" iconPos="right" class="navigate-button"
                (click)="move('pages/platform/c261')"></button>
        </div>
        <div class="card case-study-container">
            <ng-container *ngFor="let caseStudy of listCaseStudy">
                <div class="case-study p-col-3 p-d-flex pointer"
                    [routerLink]="['/pages/platform/c361/'+caseStudy.case_study_id]">
                    <div class="p-p-2 content">
                        <div class="image">
                            <img [src]="caseStudy.icon_image" alt="{{ caseStudy.title }}">

                        </div>
                        <div class="title"
                                [pTooltip]="caseStudy?.school_name + ' × ' + caseStudy?.nursery_name"
                                #tt
                                [tooltipDisabled]="!isClamped(tt)"
                                showDelay="500"
                                hideDelay="500"
                            >
                                {{ caseStudy?.school_name + ' × ' + caseStudy?.nursery_name}}
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <app-landing-footer></app-landing-footer>
</div>